import React, { useEffect } from "react";
import Navbar from "./components/navbar";
import Hero from "./components/Hero";
import AboutMe from "./components/AboutMe";
import Commitments from "./components/Commitments";
import Works from "./components/Works";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

function App() {
  // Always scroll to top and remove hash on initial load
  useEffect(() => {
    window.scrollTo(0, 0);
    if (window.location.hash) {
      // eslint-disable-next-line no-restricted-globals
      history.replaceState(
        null,
        "",
        window.location.pathname + window.location.search,
      );
    }
  }, []);

  return (
    <div className="bg-white text-gray-900 min-h-screen overflow-hidden">
      {/* Navigation */}
      <Navbar />

      {/* Hero Section */}
      <Hero />
      {/* About Me & Who I Am Combined Section */}
      <AboutMe />

      {/* My Social Commitments Section */}
      <Commitments />

      {/* Recent Works Section (Static) */}
      <Works />

      {/* Contact Section */}
      <Contact />

      {/* Footer */}
      <Footer />

      {/* Animations */}
      <style>{`
        @keyframes fade-in {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-20px); }
        }
        
        .animate-fade-in {
          animation: fade-in 0.8s ease-out forwards;
          opacity: 0;
        }
        
        .animate-fade-in-delay-1 {
          animation: fade-in 0.8s ease-out 0.2s forwards;
          opacity: 0;
        }
        
        .animate-fade-in-delay-2 {
          animation: fade-in 0.8s ease-out 0.4s forwards;
          opacity: 0;
        }

        @media (max-width: 768px) {
          h1 { font-size: 2.5rem !important; }
          h2 { font-size: 2rem !important; }
        }
      `}</style>
    </div>
  );
}

export default App;
